/**
 * @ngdoc directive
 * @name bdRevealPassword
 * @restrict E
 * 
 */
import templateHtml from './reveal-password.html';

import { $safeApply } from '@buildium/angularjs-core/dist/utilities/angularjs';

const component = {};

component.template = templateHtml;

component.bindings = {
};

component.controllerAs = 'vm';
component.transclude = true;

function RevealPasswordController($scope, $element, BdLocalize) {
    const vm = this;
    
    vm.isShowingPassword = false;
    vm.showPasswordText = null;
    vm.hidePasswordText = null;
    vm.isPasswordManagerIconVisible = false;
    vm.isRevealEnabled = true;
    
    vm.togglePassword = function togglePassword() {
        vm.isShowingPassword = !vm.isShowingPassword;
        vm.input.attr('type', vm.isShowingPassword ? 'text' : 'password');
    };

    // $postLink is needed because of the transclusion
    vm.$postLink = function postLink() {
        vm.input = $element.find('input');
        
        vm.showPasswordText = BdLocalize.getString(
            'Global.Component.RevealPassword.Tooltip.Show', 'Show'
        );

        vm.hidePasswordText = BdLocalize.getString(
            'Global.Component.RevealPassword.Tooltip.Hide', 'Hide'
        );

        let observer = new MutationObserver(function onInputMutated() {
            //mutations.forEach((mutation) => console.log(mutation));
            vm.isPasswordManagerIconVisible = vm.input[0].style.backgroundImage !== '';
            if (vm.isPasswordManagerIconVisible) { // Stop watching once this is set to true
                observer.disconnect();
                observer = null;
                $safeApply($scope);
            }
        });

        observer.observe(vm.input[0], {
            attributes: true,
            childList: true,
            characterData: true
        });
    };

    // set the input back to a password field when the form is submitted
    $scope.$on('form-submit-started', () => {
        vm.isShowingPassword = false;
        vm.input.attr('type', 'password');
    });
}

RevealPasswordController.$inject = ['$scope', '$element', 'BdLocalize'];
component.controller = RevealPasswordController;
export const RevealPasswordComponent = component;
